import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from '@cancercentrum/rcc-bootstrap';
import { memo } from 'react';
import RegvarString from './RegvarString';
import RegvarDatetime from './RegvarDatetime';
import RegvarBoolean from './RegvarBoolean';
import RegvarList from './RegvarList';
import RegvarInteger from './RegvarInteger';
import RegvarDecimal from './RegvarDecimal';
import RegvarValueDomain from './RegvarValueDomain';
import { RegvarResource } from './RegvarResource';
const RegvarInput = (props)=>{
    switch(props.regvarMetadata.dataType){
        case 'boolean':
            return /*#__PURE__*/ _jsx(RegvarBoolean, {
                ...props
            });
        case 'datetime':
            return /*#__PURE__*/ _jsx(RegvarDatetime, {
                ...props
            });
        case 'decimal':
            return /*#__PURE__*/ _jsx(RegvarDecimal, {
                ...props
            });
        case 'integer':
            return /*#__PURE__*/ _jsx(RegvarInteger, {
                ...props
            });
        case 'string':
            return /*#__PURE__*/ _jsx(RegvarString, {
                ...props
            });
        case 'list':
            return /*#__PURE__*/ _jsx(RegvarList, {
                ...props
            });
        case 'valuedomain':
            return /*#__PURE__*/ _jsx(RegvarValueDomain, {
                ...props
            });
        case 'resource':
            return /*#__PURE__*/ _jsx(RegvarResource, {
                ...props
            });
    }
    return /*#__PURE__*/ _jsxs(Alert, {
        bsStyle: "warning",
        children: [
            "Stöd saknas för datatypen ",
            /*#__PURE__*/ _jsx("strong", {
                children: props.regvarMetadata.dataType
            }),
            "."
        ]
    });
};
export default /*#__PURE__*/ memo(RegvarInput);
